// src/api/walletApi.ts

import client from './client';
import { ApiResponse, PageResponse, Retiro, WalletResumen, Comision } from '../types';

// ─── RETIROS ─────────────────────────────────────────────────────────────────

export const getRetiros = async (
  estado?: string,
  page = 0,
  size = 20,
): Promise<ApiResponse<PageResponse<Retiro>>> => {
  const params: Record<string, any> = { page, size };
  if (estado) params.estado = estado;
  const res = await client.get('/api/v1/admin/wallet/retiros', { params });
  return res.data;
};

export const aprobarRetiro = async (
  id: string,
  observacion?: string,
): Promise<ApiResponse<Retiro>> => {
  const params: Record<string, any> = {};
  if (observacion) params.observacion = observacion;
  const res = await client.put(`/api/v1/admin/wallet/retiros/${id}/aprobar`, null, { params });
  return res.data;
};

export const rechazarRetiro = async (
  id: string,
  observacion?: string,
): Promise<ApiResponse<Retiro>> => {
  const params: Record<string, any> = {};
  if (observacion) params.observacion = observacion;
  const res = await client.put(`/api/v1/admin/wallet/retiros/${id}/rechazar`, null, { params });
  return res.data;
};

export const procesarRetiro = async (id: string): Promise<ApiResponse<Retiro>> => {
  const res = await client.put(`/api/v1/admin/wallet/retiros/${id}/procesar`);
  return res.data;
};

// ─── WALLETS ─────────────────────────────────────────────────────────────────

export const getWalletMvz = async (mvzId: string): Promise<ApiResponse<WalletResumen>> => {
  const res = await client.get(`/api/v1/admin/wallet/mvz/${mvzId}`);
  return res.data;
};

export const ajusteManual = async (
  mvzId: string,
  monto: number,
  descripcion: string,
): Promise<ApiResponse<WalletResumen>> => {
  const res = await client.post(`/api/v1/admin/wallet/mvz/${mvzId}/ajuste`, null, {
    params: { monto, descripcion },
  });
  return res.data;
};

export const inicializarConfig = async (): Promise<ApiResponse<string>> => {
  const res = await client.post('/api/v1/admin/wallet/inicializar-config');
  return res.data;
};

// ─── CONFIGURACIÓN FINANCIERA ─────────────────────────────────────────────────

export interface FinancialConfig {
  id: string;
  clave: string;
  valor: string;
  descripcion?: string;
  activo: boolean;
}

export const getConfiguraciones = async (): Promise<FinancialConfig[]> => {
  const res = await client.get('/api/v1/admin/wallet/config');
  return (res.data?.content as FinancialConfig[]) ?? [];
};

export const actualizarConfiguracion = async (
  id: string,
  valor: string,
  descripcion?: string,
): Promise<FinancialConfig> => {
  const params: Record<string, string> = { valor };
  if (descripcion) params.descripcion = descripcion;
  const res = await client.put(`/api/v1/admin/wallet/config/${id}`, null, { params });
  return res.data?.content as FinancialConfig;
};
